
import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface TimeSlotMassDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  selectedCount: number;
}

const TimeSlotMassDeleteDialog: React.FC<TimeSlotMassDeleteDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  selectedCount,
}) => {
  const { t } = useTranslation();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        side="bottom" 
        className="h-screen w-full rounded-none border-0 p-0 flex flex-col modal-safe-area-aware ios-modal-safe pwa-modal-header-fix"
      >
        <SheetHeader className="p-6 border-b flex-shrink-0">
          <SheetTitle className="text-lg">
            {t('schedule.massDelete')}
          </SheetTitle>
          <SheetDescription className="text-sm text-muted-foreground">
            {t('schedule.confirmMassDelete', { count: selectedCount })}
          </SheetDescription>
        </SheetHeader>
        
        <div className="flex-1 p-6 overflow-y-auto pb-safe-bottom">
          <div className="flex gap-3 mt-6">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1"
            >
              {t('common.cancel')}
            </Button>
            <Button
              onClick={onConfirm}
              variant="destructive"
              className="flex-1"
            >
              {t('schedule.deleteSelected')}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default TimeSlotMassDeleteDialog;
